<template>
  <div class="program">
    <!-- <h3>タイムテーブル</h3>
    <hr>

    <h3>3/20(金) <span style="font-size:0.8em;">@F216 第８講義室</span></h3>
    <h5><u>趣旨説明</u></h5>
    <h4>10:00-10:10 </h4>
    <h5><u>セッション１（座長：）</u></h5>
    <h4>10:15-11:15 <b>「TBA」野田</b></h4>
    <h5 style="margin-left:10px;">~ 15分休憩 ~</h5>
    <h4>11:30-12:00 <b></b></h4>
    <h4>12:00-12:30 <b></b></h4>
    <h5 style="margin-left:10px;">~ 昼休み（1時間30分）~</h5>
    <h5><u>セッション２（座長：）</u></h5>
    <h4>14:00-14:45 <b></b></h4>
    <h4>14:45-15:15 <b></b></h4>
    <h5 style="margin-left:10px;">~ 30分休憩 ~</h5>
    <h5><u>セッション３（座長：）</u></h5>
    <h4>15:45-16:30 <b></b></h4>
    <h4>16:30-17:00 <b></b></h4>

    <br>
    <h3>3/21(土) <span style="font-size:0.8em;">@E108 理学部会議室</span></h3>
    <h5><u>セッション４（座長：）</u></h5>
    <h4>9:30-10:15 <b></b></h4>
    <h5 style="margin-left:10px;">~ 15分休憩 ~</h5>
    <h4>10:30-11:00 <b></b></h4>
    <h4>11:00-11:30 <b></b></h4>
    <h5 style="margin-left:10px;">~ 15分休憩 ~</h5>
    <h5><u>セッション５（座長：）</u></h5>
    <h4>11:45-12:30 <b></b></h4>
    <h4>12:30-13:00 <b></b></h4>
    <h5><u>総括</u></h5>
    <h4>13:00-13:10 </h4>

    <br>
    <h3>3/22(日) <span style="font-size:0.8em;">@E108 理学部会議室</span></h3>
    <h4>9:30~ 議論</h4>
    <h5>※会場を開放していますので議論に活用してください。</h5>

    <br>
    <br>
    <h3>招待講演者（50音順、敬称略）</h3>
    <hr>

    <div class="speaker">
      <h4>石井 貴昭（京都大）</h4>
      <h4>小笠原 康太（京都大）</h4>
      <h4>木村 匡志（立教大）</h4>
      <h4>古池 達彦（慶応大）</h4>
      <h4>孝森 洋介（和歌山高専）</h4>
      <h4>富沢 真也（東京工科大）</h4>
      <h4>中野 寛之（龍谷大）</h4>
      <h4>野澤 真人（基礎物理学研究所）</h4>
      <h4>野田 知宣（明治薬科大）</h4>
      <h4>道下 洋二（鹿児島大）</h4>
      <h4>森山 翔文（大阪市大）</h4>
      <h4>吉野 裕高（大阪市大）</h4>
      <h4>柳 哲文（名古屋大）</h4>
    </div> -->

    <hr>
  </div>
</template>

<script>
export default {
  name: 'Program'
}
</script>

<style>

.speaker {
  /* font-size: 18px; */
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/Program.vue